<template>
  <div class="c-app flex-row align-items-center"></div>
</template>

<script>
export default {
  name: "Logout",
  async created() {
    try {
      const result = await this.$store.dispatch("auth/logout");
      await this.$router.replace("/login");
    } catch (e) {
      await this.$router.replace("/login");
    }
  },
};
</script>
